import { render, staticRenderFns } from "./MchBaseDlg.vue?vue&type=template&id=6d45658b&scoped=true"
import script from "./MchBaseDlg.vue?vue&type=script&lang=js"
export * from "./MchBaseDlg.vue?vue&type=script&lang=js"
import style0 from "./MchBaseDlg.vue?vue&type=style&index=0&id=6d45658b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d45658b",
  null
  
)

export default component.exports